module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/power-5-percentage.20beeb65.mp4";